{
    "ClientConfiguration_Table_Headers_Description": "Beschrijving",
    "ClientConfiguration_Table_Headers_TelSys": "Telefonieserver",
    "ClientConfiguration_Table_Headers_Partition": "Partitie",
    "ClientConfiguration_Table_Headers_Device": "Apparaat",
    "ClientConfiguration_Footer_Add": "Toevoegen",
    "ClientConfiguration_Footer_View": "Weergave",
    "ClientConfiguration_Footer_Change": "Wijziging",
    "ClientConfiguration_Footer_Delete": "Verwijderen",
    "ClientConfiguration_Footer_Selected": "{} Geselecteerd",
    "ClientConfiguration_Footer_NoRows": "Hier is niets te zien...",
    "ClientConfiguration_No_Available_CMEs": "U hebt geen CME's met de vereiste capaciteiten",
    "NAME": "ClientConfigurationLanguage",
    "ClientConfiguration_Table_Headers_CME": "Telefonieserver",
    "ClientConfiguration_Admin_Filters_CME": "CME",
    "ClientConfiguration_Admin_Filters_IncludeChildCMEs": "Inclusief kinder-CME",
    "ClientConfiguration_Admin_Filters_Search": "Zoekopdracht"
}